import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { serviceConstants } from 'src/app/constants/service.constants';
import { AdobePdfViewerService } from 'src/app/services/adobe-pdf-viewer.service';
import { UserService } from 'src/app/services/user.service';
import { DeleteBoxComponent } from '../delete-box/delete-box.component';
import { LoaderService } from 'src/app/services/loader.service';
import { ReviewService } from 'src/app/services/common/review.service';
import { ReferencesDocumentsComponent } from '../my-reviews/references-documents/references-documents.component';

@Component({
  selector: 'app-approval-doc-preview',
  standalone: true,
  imports: [CommonModule,FormsModule],
  providers: [],
  templateUrl: './approval-doc-preview.component.html',
  styleUrl: './approval-doc-preview.component.scss'
})
export class ApprovalDocPreviewComponent {

  Content: any;
  Comments: string;
  Status: string;
  ApprovalID: string;
  ApproverID: string;
  ApplicationCode: string;
  DocumentId: string;
  Data: any;

  constructor(
    private pdfViewer: AdobePdfViewerService,
    private userService:UserService,
    private ngModal: NgbActiveModal,
    private modalService: NgbModal,
    private reviewService: ReviewService,
    private loaderService: LoaderService,
  ) { }
  
  ngOnInit() {
    let loggedUserID = this.userService.getUserID();
    this.ApprovalID = this.Content.ApprovalId;
    this.ApproverID = this.Content.ApproverID;
    this.DocumentId = this.Content.content.FileID;
    this.ApplicationCode = this.Content.ApplicationCode;
    this.OpenApprovalDocPreview(this.Content.content);
    this.UpdateApproverWorkActivityStatus("Opened");
    this.GetAppDocDetails();
  }
  
  OpenApprovalDocPreview(doc: any) {
    this.pdfViewer.ready().then(() => {
    const fileId = this.Content.content.FileID;
    const fileName = this.Content.content.FileName;
    
    const previewUrl = serviceConstants.apiURL + "api/Login/Preview?type=approval&id=" + fileId;
     this.pdfViewer.previewFile(
       "approvefile-preview-div",
       previewUrl,
       fileName || ' ',
       {
         showPageControls: true,
         showLeftHandPanel: true
       }
     );
    });
  }

  onCompleteClick(){
      let st = this.Status === "1" ? "Approve" : this.Status === "2" ? "Resubmit" : "Reject";
      var params = { Comments: this.Comments, 
                     ApprovalId: this.Content.ApprovalId,
                     DocStatus: st,
                     ApprovalDocId: this.Content.content.FileID,
                     ApplicationCode: this.Content.ApplicationCode,
                     IsCompletion: true
                   };
      let modalRefe = this.modalService.open(DeleteBoxComponent, { backdrop: false });
      modalRefe.componentInstance.Content = { heading: 'Confirmation', custommessage: 'You are about to complete the Approval for ' + this.Content.content.FileName + '; do you want to proceed?', ProceedButtonName: "Confirm", TerminateButtonName: "Cancel" };
      modalRefe.result.then(result => {
        if (result == "okclick") {
         this.loaderService.isLoading.next(true);
          setTimeout(() => {
            this.loaderService.isLoading.next(false);
            this.reviewService.UpdateDocReviewerStatus("api/Approval/CompleteDocumentApproval", params).subscribe(result => {
              this.ngModal.close("complete");
           });
          }, 5000); 
        }
      });
    }
  
  Closepopup() {
    this.ngModal.close("close");
  }

  ngOnDestroy() {
    this.UpdateApproverWorkActivityStatus("Closed");
  }

 
  UpdateApproverWorkActivityStatus(AppDocStatus: string) {
    this.reviewService.GetReviews("api/Approval/UpdateApproverWorkActivityStatus?ApprovalId=" + this.ApprovalID +"&ApproverID="+ this.ApproverID  + "&AppDocStatus=" + AppDocStatus).subscribe(result => {
      if (result) {
      } else {
      }
    });
  }

  SaveAndClose(){
    let st = this.Status === "1" ? "Approve" : this.Status === "2" ? "Resubmit" : "Reject";
      var params = { Comments: this.Comments, 
                     ApprovalId: this.Content.ApprovalId,
                     DocStatus: st,
                     ApprovalDocId: this.Content.content.FileID,
                     ApplicationCode: this.Content.ApplicationCode,
                     IsCompletion: false
                   };
      this.reviewService.UpdateDocReviewerStatus("api/Approval/SaveAndCloseDocumentApproval", params).subscribe(result => {
      this.ngModal.close("close");
      });
  }

  GetAppDocDetails() {
    this.reviewService.GetReviews("api/Approval/GetAppDocDetails?ApprovalId=" + this.ApprovalID + "&ApproverID=" + this.ApproverID + "&ApplicationCode=" + this.ApplicationCode + "&DocumentID=" + this.DocumentId).subscribe((result: any) => {
      if (result !== null) {
        this.Data = result;
        this.Comments = result.Data?.COMMENTS || '';
        if (this.Data.Data?.APPROVERSTATUS === 0) {
          this.Status = "1"; // Default to "Approve" if status is 0
        }
        else {
        this.Status = (result.Data?.APPROVERSTATUS ?? 1).toString();
      }
      } 
    });
  }

  openReferenceDocs() {
      let modalRef = this.modalService.open(ReferencesDocumentsComponent, {
          backdrop: false,
          keyboard: false,
          windowClass: 'modal-vlg right modal-right',
          animation: true
        });
        modalRef.componentInstance.Content= {
          heading: 'Reference Documents',
          content: { ApprovalID:this.Content.ApprovalId}
        }
        modalRef.result.then(result => {    
        });
  }

}
